"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactMoment = void 0;
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _moment = _interopRequireDefault(require("moment/moment"));
require("moment/min/locales");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @todo move to core */
const useReactMoment = () => {
  const locale = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getLocales) || '';
  const momentLocale = locale.slice(0, 2);
  _moment.default.locale(momentLocale);
  _moment.default.updateLocale(momentLocale, {
    week: {
      dow: 1,
      doy: 7
    }
  });
  return {
    reactMoment: _moment.default,
    momentLocale
  };
};
exports.useReactMoment = useReactMoment;